import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {DataListContentItem} from "@/models";

export class DataListContentService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public listItemsByDataListId(id: number, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<DataListContentItem[]>(`/api/DataListContent/GetByDataListId/${id}`, null, cancelToken);
    }

    public GetAllDataListContents(query: string) {
        return this.baseApiFactory.get<any[]>('/api/DataListContent?' + query);
    }

    public InsertOrUpdateDataListContents(dataListId: number, items: DataListContentItem[], cancelToken?: AbortSignal) {
        return this.baseApiFactory.post(`/v2/api/DataListContent/update-or-insert/${dataListId}`, items, cancelToken);
    }

    public updateOrderDataListContents(dataListId: number, items: { sku: string }[], cancelToken?: AbortSignal) {
        return this.baseApiFactory.post(`/v2/api/DataListContent/update-order/${dataListId}`, items, cancelToken);
    }

    public updateDefaultColorBySku(dataListId: number, sku: string, colorCode: string, cancelToken?: AbortSignal) {
        return this.baseApiFactory.put(`/v2/api/DataList/${dataListId}/${sku}/color`, {
            colorCode
        }, cancelToken);
    }

    public deleteBySku(dataListId: number, sku: string, cancelToken?: AbortSignal) {
        return this.baseApiFactory.delete(`/v2/api/DataList/${dataListId}/${sku}`, null, cancelToken);
    }

    public DeleteBySkuAndDatalistId(value: any) {
        return this.baseApiFactory.post('/api/DataListContent/DeleteBySkuAndDatalistId', value);
    }

    public UpdateColor(value: any) {
        return this.baseApiFactory.post('/api/DataListContent/UpdateColor', value);
    }
}

lazyRegister.service('DataListContentService', DataListContentService);
